var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-200 -7598)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(200 7598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "world-grid",
    transform: "translate(224.772 7624.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M64.9,54.278h-6.04a1.061,1.061,0,1,0,0,2.123H64.9a5.445,5.445,0,0,1,5.432,5.446v40.536a5.445,5.445,0,0,1-5.432,5.446H7.554a5.444,5.444,0,0,1-5.432-5.445V94.868a1.061,1.061,0,0,0-2.123,0v7.514a7.57,7.57,0,0,0,7.554,7.568H29.1l-2.137,6.979H22.258a1.061,1.061,0,1,0,0,2.123H50.2a1.061,1.061,0,1,0,0-2.123H45.491l-2.137-6.979H64.9a7.57,7.57,0,0,0,7.554-7.568V61.847A7.57,7.57,0,0,0,64.9,54.278ZM29.185,116.93l2.137-6.979h9.812l2.137,6.979Z",
    transform: "translate(0 -46.597)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1.061,90.994a1.061,1.061,0,0,0,1.061-1.061V61.847A5.445,5.445,0,0,1,7.554,56.4h3.082a1.061,1.061,0,1,0,0-2.123H7.554A7.57,7.57,0,0,0,0,61.847V89.933a1.061,1.061,0,0,0,1.061,1.061Z",
    transform: "translate(0 -46.598)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M432.364,86.129a3.362,3.362,0,0,0-3.356-3.361H425.23a1.061,1.061,0,1,0,0,2.123h3.777a1.237,1.237,0,0,1,1.233,1.238V106.94a1.061,1.061,0,1,0,2.123,0Z",
    transform: "translate(-364.143 -71.055)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M93.91,122.631V111.937a1.061,1.061,0,0,0-2.123,0v10.694a1.237,1.237,0,0,1-1.233,1.238H33.28a1.237,1.237,0,0,1-1.233-1.238v-36.5a1.237,1.237,0,0,1,1.233-1.238h2a1.061,1.061,0,1,0,0-2.123h-2a3.362,3.362,0,0,0-3.356,3.361v36.5a3.362,3.362,0,0,0,3.356,3.361H90.554A3.362,3.362,0,0,0,93.91,122.631Z",
    transform: "translate(-25.689 -71.055)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M57.616,402.976a1.061,1.061,0,0,0,0,2.123h4.336a1.061,1.061,0,0,0,0-2.123Z",
    transform: "translate(-48.552 -345.949)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M117.616,402.976a1.061,1.061,0,0,0,0,2.123h4.336a1.061,1.061,0,0,0,0-2.123Z",
    transform: "translate(-100.061 -345.949)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M108.714,48.659a24.343,24.343,0,0,0,20.98-11.972,1.061,1.061,0,1,0-1.827-1.08,22.349,22.349,0,0,1-4.906,5.769q-1.309-.589-2.713-1.06a33.377,33.377,0,0,0,3.711-14.924h6.958a22.1,22.1,0,0,1-1.15,6.082,1.061,1.061,0,1,0,2.01.683A24.344,24.344,0,0,0,108.714,0,24.11,24.11,0,0,0,97.685,2.633,24.576,24.576,0,0,0,89.809,9a3.536,3.536,0,0,0-3.543,5.893,24.112,24.112,0,0,0-1.9,9.441,24.367,24.367,0,0,0,24.35,24.33Zm-22.2-23.268H93.47a33.377,33.377,0,0,0,3.711,14.924q-1.4.469-2.7,1.056A22.169,22.169,0,0,1,86.512,25.391Zm9.937,17.45q.908-.36,1.861-.663a18.7,18.7,0,0,0,2.323,2.839A22.193,22.193,0,0,1,96.449,42.841Zm11.2,3.622c-2.623-.361-5.108-2.055-7.173-4.886a35.181,35.181,0,0,1,7.173-.921Zm0-7.93a37,37,0,0,0-8.388,1.161,30.887,30.887,0,0,1-3.671-14.3h12.059V28.3a3.537,3.537,0,0,0,0,6.749v3.483Zm2.123,7.93V40.657a35.181,35.181,0,0,1,7.173.921C114.884,44.409,112.4,46.1,109.776,46.464Zm11.214-3.618q-.536.356-1.092.68a22.02,22.02,0,0,1-3.107,1.5,18.69,18.69,0,0,0,2.329-2.845Q120.076,42.483,120.99,42.845Zm1.2-24.63a1.414,1.414,0,1,1,1.416-1.414A1.417,1.417,0,0,1,122.189,18.215Zm8.727,5.053h-6.958c-.03-1.1-.105-2.2-.226-3.285a3.536,3.536,0,0,0-1.409-6.717,28.187,28.187,0,0,0-2.075-4.922q1.4-.469,2.7-1.056A22.168,22.168,0,0,1,130.916,23.268ZM120.98,5.818q-.908.36-1.861.663a19.085,19.085,0,0,0-1.935-2.433q-.2-.211-.4-.411A22.181,22.181,0,0,1,120.98,5.818ZM109.776,2.2c2.638.372,5.134,2.115,7.167,4.886A35.186,35.186,0,0,1,109.776,8Zm0,7.929a37.007,37.007,0,0,0,8.386-1.16,25.539,25.539,0,0,1,2.112,4.862,3.536,3.536,0,0,0,1.357,6.466c.108.98.176,1.974.2,2.974H109.776Zm0,15.265h12.059a30.89,30.89,0,0,1-3.671,14.3,37.007,37.007,0,0,0-8.388-1.161V35.05a3.537,3.537,0,0,0,0-6.749Zm-1.061,4.87a1.414,1.414,0,1,1-1.416,1.414A1.417,1.417,0,0,1,108.714,30.261ZM107.653,2.2V8a35.184,35.184,0,0,1-7.184-.923C102.5,4.3,104.993,2.564,107.653,2.2ZM98.647,4.525q1-.507,2.027-.908a18.623,18.623,0,0,0-2.362,2.864q-.958-.3-1.872-.667A22.017,22.017,0,0,1,98.647,4.525Zm-9.9,6.43a1.414,1.414,0,1,1-1.416,1.414A1.417,1.417,0,0,1,88.748,10.955Zm-.587,4.9a3.535,3.535,0,0,0,3.392-5.642,22.445,22.445,0,0,1,2.916-2.93q1.308.589,2.712,1.059a29.081,29.081,0,0,0-2.528,6.479,1.061,1.061,0,1,0,2.052.542,26.835,26.835,0,0,1,2.55-6.4,36.994,36.994,0,0,0,8.4,1.163V23.268H95.593c.031-1.1.111-2.2.238-3.274a1.061,1.061,0,1,0-2.108-.25c-.137,1.156-.222,2.337-.254,3.523H86.511a21.94,21.94,0,0,1,1.65-7.41Z",
    transform: "translate(-72.425)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M75.09,298.688H70.541a1.061,1.061,0,1,0,0,2.123H75.09a1.061,1.061,0,1,0,0-2.123Z",
    transform: "translate(-59.648 -256.419)",
    fill: "#ed8e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M69.48,334.749a1.061,1.061,0,0,0,1.061,1.061h7.374a1.061,1.061,0,1,0,0-2.123H70.541A1.061,1.061,0,0,0,69.48,334.749Z",
    transform: "translate(-59.648 -286.466)",
    fill: "#ed8e88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldGrid);
export default __webpack_public_path__ + "static/media/world-grid.adef5b9a06435ed1a8c49a59f4898399.svg";
export { ForwardRef as ReactComponent };